module.exports = __webpack_public_path__ + "img/index-logo.e3e4140.png";